import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

import Button from './Button';
import Search from './Search';
import useUser from '../hooks/useUser';

const HeaderDiv = styled.div`
  display: flex;
  @media screen and (min-width: 901px) {
    height: 102px;
    justify-content: space-between;
  }
  @media screen and (max-width: 900px) {
    align-items: center;
    flex-direction: column;
    padding-bottom: 12px;
  }
`;
const Logo = styled.h1`
  font-weight: normal;
  font-size: 38px;
  line-height: 52px;
  text-align: center;
  color: #f6f6de;
  cursor: pointer;
  @media screen and (min-width: 901px) {
    padding-top: 20px;
    width: 390px;
  }
  @media screen and (max-width: 900px) {
    padding-top: 12px;
  }
`;
const MenuDiv = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  height: 52px;
  @media screen and (min-width: 901px) {
    gap: 16px;
    padding-right: 40px;
    padding-top: 24px;
  }
  @media screen and (max-width: 900px) {
    padding-top: 4px;
  }
`;
const UserActions = styled.div`
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

const SiteHeader = () => {
  const navigate = useNavigate();
  const { isAdmin, user } = useUser();
  const provider = new GoogleAuthProvider();

  return (
    <HeaderDiv>
      <Logo onClick={() => navigate('/')}>Nielson Recipes</Logo>
      <MenuDiv>
        <Search />
        <UserActions>
          {isAdmin && (
            <Button onClick={() => navigate('/manage')}>Manage</Button>
          )}
          {!user && (
            <Button onClick={() => signInWithPopup(getAuth(), provider)}>
              Sign In
            </Button>
          )}
        </UserActions>
      </MenuDiv>
    </HeaderDiv>
  );
};

export default SiteHeader;
